const children = [
  {
    path: '',
    component: () => import('@/views/schemeEcosystem/index.vue'),
    children: [
      {
        path: '',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'schemeEcosystem',
        meta: { title: '首页', currentPage: 'dashboard' },
        component: () => import('@/views/schemeEcosystem/pages/Home.vue')
      },
      {
        path: 'customer-recommendation',
        name: 'schemeEcosystemCustomerRecommendation',
        meta: { title: '客户推荐', currentPage: 'customer-recommendation' },
        component: () => import('@/views/schemeEcosystem/pages/CustomerRecommendation.vue')
      },
      {
        path: 'opportunity-recommendation',
        name: 'schemeEcosystemOpportunityRecommendation',
        meta: { title: '商机推荐', currentPage: 'opportunity-recommendation', recommendResource: 'scheme' },
        component: () => import('@/views/opportunities/index.vue')
      },
      {
        path: 'solution-exhibition',
        name: 'schemeEcosystemSolutionExhibition',
        meta: { title: '解决方案展区', currentPage: 'solution-exhibition' },
        component: () => import('@/views/schemeEcosystem/pages/SolutionExhibition.vue')
      },
      {
        path: 'solution-decoration',
        name: 'schemeEcosystemSolutionDecoration',
        meta: { title: '方案装修', currentPage: 'solution-decoration' },
        component: () => import('@/views/schemeEcosystem/pages/SolutionDecoration.vue')
      },
      {
        path: 'exhibition-embed-demo',
        name: 'schemeEcosystemExhibitionEmbedDemo',
        meta: { title: '展区外部调用示例', currentPage: 'exhibition-embed-demo' },
        component: () => import('@/views/schemeEcosystem/pages/ExhibitionEmbedDemo.vue')
      },
      {
        path: 'fulfillment',
        name: 'schemeEcosystemFulfillment',
        meta: { title: '履约能力', currentPage: 'fulfillment' },
        component: () => import('@/views/schemeEcosystem/pages/Fulfillment.vue')
      },
      {
        path: 'dialogue-center',
        name: 'schemeEcosystemDialogueCenter',
        meta: { title: '对话中心', currentPage: 'dialogue-center' },
        component: () =>
          import('@/views/schemeEcosystem/pages/DialogueCenterRoutePlaceholder.vue')
      },
      {
        path: 'resource-center',
        name: 'schemeEcosystemResourceCenter',
        meta: { title: '资料中心', currentPage: 'resource-center' },
        component: () => import('@/views/schemeEcosystem/pages/ResourceCenter.vue')
      },
      {
        path: 'authentication-center',
        name: 'schemeEcosystemAuthenticationCenter',
        meta: { title: '认证中心', currentPage: 'authentication-center' },
        component: () => import('@/views/schemeEcosystem/pages/AuthenticationCenter.vue')
      },
      {
        path: 'basic-info',
        name: 'schemeEcosystemBasicInfo',
        meta: { title: '基础信息', currentPage: 'basic-info' },
        component: () => import('@/views/schemeEcosystem/pages/BasicInfo.vue')
      },
      {
        path: 'platform-policy',
        name: 'schemeEcosystemPlatformPolicy',
        meta: { title: '平台政策', currentPage: 'platform-policy' },
        component: () => import('@/views/schemeEcosystem/pages/PlatformPolicy.vue')
      },
      {
        path: 'contact-us',
        name: 'schemeEcosystemContactUs',
        meta: { title: '联系我们', currentPage: 'contact-us' },
        component: () => import('@/views/schemeEcosystem/pages/ContactUs.vue')
      }
    ]
  }
]

export { children }
export default children
